<div [ngClass]="{ active: isActive }">
    <app-brain-tab-favorites [group]="group" (login)="handleLogin()"></app-brain-tab-favorites>
    <h3>Resources</h3>
    <ul [style.maxHeight]="maxHeight">
        <li *ngFor="let link of group.links; trackBy: trackByItem">
            <a [href]="link.url" target="_blank">{{ link.title }}</a>
        </li>
    </ul>
</div>
